import React from 'react';

import {
	Box,
	Button,
	Grid,
	IconButton,
	Menu,
	MenuItem,
	Typography,
	styled
} from '@mui/material';
import { DragIndicator, MoreHoriz } from '@mui/icons-material';
import fp from 'lodash/fp';

import { useMenu } from 'hooks';

const StyledGrid = styled(Grid)({
	minHeight: 80,
	paddingLeft: 20,
	paddingRight: 20
});

const StyledGridItem = styled(Grid)({
	verticalAlign: 'center',
	'&:hover': { backgroundColor: '#fff' }
});

const StyledTypography = styled(Typography)({
	paddingTop: 20
});

const StyledIcon = styled(DragIndicator)({
	color: '#757575',
	marginLeft: 20,
	marginTop: 20
});

const StyledButton = styled(Button)({
	paddingTop: 20,
	paddingBottom: 20
});

const TrainingPlanDrillItem = ({
	drill,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleClick(drill, e)}>Show</MenuItem>
			<MenuItem onClick={(e) => handleEditClick(drill, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(drill, e)}>Delete</MenuItem>
		</Menu>
	);

	const GridItem = ({ name, drill, handleClick, ...rest }) => {
		return (
			<StyledGridItem item md={2} xs={12} {...rest}>
				<StyledButton onClick={(e) => handleClick(drill, e)}>
					<StyledTypography variant="body1">{name}</StyledTypography>
				</StyledButton>
			</StyledGridItem>
		);
	};

	return (
		<StyledGrid container spacing={1}>
			<StyledGridItem item md={1} xs={12}>
				<StyledIcon />
			</StyledGridItem>
			<GridItem
				item
				md={2}
				xs={12}
				name={`Drill ${drill.position}`}
				drill={drill}
				handleClick={handleClick}
			/>
			<GridItem
				item
				md={3}
				xs={12}
				name={drill.name}
				drill={drill}
				handleClick={handleClick}
			/>
			<GridItem
				item
				md={3}
				xs={12}
				name={drill.category_names?.join(', ')}
				drill={drill}
				handleClick={handleClick}
			/>
			<GridItem
				item
				md={2}
				xs={12}
				name={drill.published ? 'Yes' : 'No'}
				drill={drill}
				handleClick={handleClick}
			/>

			<StyledGridItem item md={1} xs={12}>
				<IconButton onClick={(e) => handleToggleMenu(e)}>
					<MoreHoriz />
					{renderMenu()}
				</IconButton>
			</StyledGridItem>
		</StyledGrid>
	);
};

export default TrainingPlanDrillItem;
